// Home page "Recently viewed" + "Because you viewed <product>" (sections/yc-home-personal.liquid).
// Reads the product-view history the product page keeps in localStorage, then renders cards through
// Shopify's search and product-recommendations section rendering. Shows nothing without history.
(function () {
  var KEY = '__sm_theme_recently';
  var box = document.querySelector('.yc-hp');
  if (!box) return;

  var maxAge = (Number((window.recentlyViewed || {}).expirationDays) || 30) * 864e5;
  var limit = Number(box.dataset.limit) || 10;

  function history() {
    try {
      var now = Date.now();
      var seen = {};
      return (JSON.parse(localStorage.getItem(KEY)) || [])
        .filter(function (i) { return i && i.productId && now - i.timestamp < maxAge; })
        .sort(function (a, b) { return b.timestamp - a.timestamp; })
        .map(function (i) { return String(i.productId); })
        .filter(function (id) { return seen[id] ? false : (seen[id] = true); });
    } catch (e) { return []; }
  }

  function cards(url) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.yc-hp__item'));
      });
  }

  function fill(slot, items) {
    var wrap = document.createElement('div');
    wrap.className = 'yc-hp__cards';
    items.forEach(function (el) { wrap.appendChild(document.adoptNode(el)); });
    slot.innerHTML = '';
    slot.appendChild(wrap);
    slot.closest('.yc-hp__row').classList.add('is-on');
  }

  function done() { box.classList.add('is-ready'); if (!box.querySelector('.yc-hp__row.is-on')) box.classList.remove('is-on'); }

  var ids = history().slice(0, limit);
  if (!ids.length) { box.classList.remove('is-on'); return; }

  var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
  var rv = cards(box.dataset.searchUrl + '&q=' + encodeURIComponent(q)).then(function (items) {
    // Search returns its own order; put the cards back in the order they were viewed.
    var byId = {};
    items.forEach(function (el) { byId[el.dataset.productId] = el; });
    var ordered = ids.map(function (id) { return byId[id]; }).filter(Boolean);
    if (ordered.length) fill(box.querySelector('[data-yc-hp-rv]'), ordered);
    return ordered;
  }).catch(function () { return []; });

  var bv = rv.then(function (ordered) {
    if (!ordered.length) return;
    var last = ordered[0];
    return cards(box.dataset.recsUrl + '&product_id=' + encodeURIComponent(last.dataset.productId)).then(function (items) {
      var shown = {};
      ids.forEach(function (id) { shown[id] = true; });
      var fresh = items.filter(function (el) { return !shown[el.dataset.productId]; }).slice(0, limit);
      if (fresh.length < 3) return;
      var name = (last.dataset.title || '').split(/ [-|–:] | \| |\[|\(/)[0].trim();
      if (name.length > 42) name = name.slice(0, 40).replace(/\s+\S*$/, '') + '…';
      var title = (box.dataset.bvHeading || '').replace('[title]', '“' + name + '”');
      box.querySelector('[data-yc-hp-bv-title]').textContent = title;
      fill(box.querySelector('[data-yc-hp-bv]'), fresh);
    });
  }).catch(function () {});

  Promise.all([rv, bv]).then(done, done);

  var clear = box.querySelector('[data-yc-hp-clear]');
  if (clear) clear.addEventListener('click', function () {
    try { localStorage.removeItem(KEY); } catch (e) {}
    box.classList.remove('is-on');
  });
})();
